import React, { useEffect, useCallback, useState} from 'react';
import GroupGeneticAlgo from './GroupGeneticAlgo.js';
import PlaneAlgo from "components/effects/plane/PlaneAlgo.js";
import {connect} from 'react-redux';
import PlaneSnapshots from "components/effects/plane/PlaneSnapshots.js";

const PlaneToolbar = ({
    setSelected,
    isRegionMode,
    effect,
    isDraggable,
    setExpanded,
    expanded,
    setIsRegionMode,
    unmap,
    selected,
    mergeGroups,
    group,
    grouped,
    setDrawMode,
    drawMode,
    children
}) => { 
    const _setExpanded = useCallback((e) => {
        effect.scriptExpanded = e;
        setExpanded(e);
    }, [effect, setExpanded]);

    const onClickMacro = useCallback(() => {
        effect.createMacro(selected);
    }, [effect, selected]);

    const onClickFreeMacro = useCallback(() => {
        let parameters = selected[0].parameters;
        effect.freeMacro(selected[0]);
        setSelected(parameters);
    }, [effect, selected, setSelected]);

    let selectedGroups = new Set();
    selected.forEach(x => selectedGroups.add(x.hasGroup));
    let allowMerge = selectedGroups.size >= 2;
    let allowMacro = selected.length > 0;
    let allowFree = selected[0] && selected[0].isPlaneMacro;
    return(<div className="plane-toolbar">
            <div className="plane-toolbar-inner">
              <div className="inner-part-1">
              <div className="plane-group-buttons">
                <div
                  onClick={() => unmap()}
                  className={selected.length > 0 ? "plane-btn" : "plane-btn disabled"}>
                  unmap
                </div>
                {allowMerge ?
                 <div
                   onClick={mergeGroups}
                   className="plane-btn">
                   merge 
                 </div>
                 : ''}
                <div
                  onClick={() => group(!grouped)}
                  className={selected.length > 0 ? "plane-btn" : "plane-btn disabled"}>
                  {grouped ? "ungroup" : "group"}
                </div>
                <div
                  className={isRegionMode ? "plane-btn selected" : selected.length > 0 ? "plane-btn" : "plane-btn disabled"}
                  onClick={() => setIsRegionMode(!isRegionMode)}>
                  bounds
                </div>
                <div
                  onClick={allowFree ? onClickFreeMacro : onClickMacro}
                  className={allowMacro ? "plane-btn" : "plane-btn disabled"}>
                  {allowFree ? "free macro" : "macro"}
                </div>
                <img
                  onClick={() => setDrawMode(!drawMode)}
                  src="/pencil.svg" className={drawMode ? "pencil-icon enabled" : "pencil-icon"}/>
                <img
                  onClick={() => effect.resetValues()}
                  src="/reset.svg" className="reset-icon"/>
             </div>
              <PlaneSnapshots isDraggable={true} effect={effect}/>
              <GroupGeneticAlgo group={effect}/>
              {true ? <PlaneAlgo isDraggable={isDraggable} setExpanded={_setExpanded} expanded={expanded} selected={selected} effect={effect}/> : ''}
              </div>
              {children}
            </div>
             {false ? <PlaneAlgo isDraggable={isDraggable} setExpanded={_setExpanded} expanded={expanded} selected={selected} effect={effect}/> : ''}
           </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaneToolbar);
